import React from 'react';
import List from '../components/List';
import Hero from '../components/Hero';
const Home = () => {
  return (
    <div>
      <Hero />
      <List />
    </div>
  );
};

export default Home;
